import { types } from 'mobx-state-tree';

import Actions from './actions';
import Views from './views';

const IdleTimeout = types
  .model({
    time: types.optional(types.maybeNull(types.number), null),
    scriptAlreadyLoaded: types.optional(types.boolean, false),
  })
  .views(Views)
  .actions(Actions);

export default IdleTimeout;
